/* REACT IMPORTS */
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../src/context/AuthContext";
import { StoresProvider } from "../src/context/StoresContext";
import { UsersProvider } from "../src/context/UserContext";
import { ProductProvider } from "../src/context/ProductContext";
import { ExpiredProductProvider } from "../src/context/ExpiredProductContext";
import { TemplateProvider } from "../src/context/TemplateContext";
import { FilterExpiredProductProvider } from "../src/context/FilterExpiredProductContext";
import { ClientProvider } from "../src/context/ClientContext";
import { MainContent } from "./components/main/MainContent";

function App() {
  return (
    <div>
      <BrowserRouter basename="/painel">
        <AuthProvider>
          <StoresProvider> 
          <UsersProvider>
          <ProductProvider>
          <TemplateProvider>
          <ExpiredProductProvider>
          <FilterExpiredProductProvider>
          <ClientProvider>
          <MainContent/>
          </ClientProvider>
          </FilterExpiredProductProvider>
          </ExpiredProductProvider>
          </TemplateProvider> 
          </ProductProvider> 
          </UsersProvider>
          </StoresProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
